import { API_BASE_URL } from '../const/constants';

async function apiRequest(endpoint, method = 'GET', body = null, headers = {}) {
    const config = {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...headers,
        },
        body
    };

    if (body) {
        config.body = JSON.stringify(body);
    }

    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    
    if (!response.ok) {
        // throw new Error(response.Error);
        // alert(response.text());
    }

    return response;
}

export async function get(endpoint, headers = {}) {
    return apiRequest(endpoint, 'GET', null, headers);
}

export async function post(endpoint, body, headers = {}) {
    return apiRequest(endpoint, 'POST', body, headers);
}

export async function del(endpoint, body, headers = {}) {
    return apiRequest(endpoint, 'DELETE', body, headers);
}

export async function put(endpoint, body, headers = {}) {
    return apiRequest(endpoint, 'PUT', body, headers);
}

// Default export로 모든 함수들을 객체로 내보내기
const ApiRequest = {
    get,
    post,
    put,
    del,
    apiRequest
};

export default ApiRequest;
